import React from 'react';

import Button from '@elements/Button';
import CardArticle from '@elements/CardArticle';
import Dropdown from '@elements/Dropdown';
import IconFilter from '@svg/icons/filter.svg';
import { getClasses } from '@utils';

import './style.css';

type DropdownItem = {
  __typename: string,
  contentful_id: string,
  title: string,
  moreArticlesSlug: string,
};

type ArticleProps = {
  __typename: string,
  contentful_id: string,
  title: string,
  slug: string,
  type: string,
  publishDate: string,
  heroImage: {
    title: string,
  },
  categories: Array<{
    title: string,
  }>,
};

type ArticlesGridProps = {
  item: {
    contentful_id: string,
    title: string,
    subtitle: string,
    classes: string,
    firstisBig: boolean,
    maxArticles: number,
    htmlId: string,
  },
  extra?: {
    useDropdownButton?: boolean,
    articlesList?: ArticleProps[],
    dropDownList?: DropdownItem[],
    dropDownSelected?: DropdownItem,
  };
  onChange?: (ev) => void,
}

const ArticlesGrid = ({
  item,
  extra = {},
  onChange,
}: ArticlesGridProps): JSX.Element => {
  const {
    title, 
    subtitle, 
    classes = '', 
    firstisBig,
    maxArticles,
    htmlId,
  } = item;

  const {
    articlesList,
    dropDownList,
    dropDownSelected,
    useDropdownButton,
  } = extra;

  const newArticlesList = maxArticles
    ? articlesList?.filter((_, index: number) => maxArticles > index)
    : articlesList;

  const mainClasses = getClasses(
    'articles-grid--main',
    classes,
  );

  return (
    <div className={mainClasses} id={htmlId} >
      {
        title && (
          <section className="articles-grid__title">
            <div className="articles-grid__left-side">
              <hr className="articles-grid__line" />
              <h2>{title}</h2>
              <p>{subtitle}</p>
            </div>
            {
              useDropdownButton && (
                <div className="articles-grid__right-side">
                  <Dropdown 
                    listChilds={dropDownList} 
                    onClick={onChange}
                  >
                    <IconFilter className='mr-4' />
                    <span>
                      {dropDownSelected?.title}
                    </span>
                  </Dropdown>
                </div>
              )
            }
          </section>
        )
      }
      <section className="articles-grid__inner">
        {
          newArticlesList?.map((article: ArticleProps, index: number) => {
            const childClassName = getClasses(
              `articles-grid__card`,
              firstisBig && index === 0 && 'articles-grid__first-big',
            );

            return (
              <CardArticle
                key={article.contentful_id}
                article={article}
                childClassName={childClassName}
              />
            );
          })
        }
      </section>
    </div>
  );
};

export default ArticlesGrid;
